import React, { ReactNode } from 'react';
import { themePalette } from '@theme/muiTheme';

export const matchesSearch = (name: string, needle: string): boolean => {
  if (!needle) return false;

  return name.toLowerCase().includes(needle);
};

type HighlightSegment = {
  text: string;
  isMatch: boolean;
};

export const getHighlightSegments = (
  text: string,
  needle: string,
): HighlightSegment[] => {
  if (!needle) return [{ text, isMatch: false }];

  const segments: HighlightSegment[] = [];
  const lowerText = text.toLowerCase();
  let cursor = 0;

  for (
    let index = lowerText.indexOf(needle, cursor);
    index !== -1;
    index = lowerText.indexOf(needle, cursor)
  ) {
    if (index > cursor) {
      segments.push({ text: text.slice(cursor, index), isMatch: false });
    }

    segments.push({
      text: text.slice(index, index + needle.length),
      isMatch: true,
    });

    cursor = index + needle.length;
  }

  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), isMatch: false });
  }

  return segments;
};

export const renderHighlightedText = (
  text: string,
  needle: string,
  highlightColor: string,
  isListMenu: boolean = false,
): ReactNode => {
  if (!needle || !matchesSearch(text, needle)) return text;

  return getHighlightSegments(text, needle).map((segment, index) =>
    segment.isMatch ? (
      // eslint-disable-next-line react/no-array-index-key
      <mark
        key={index}
        style={{
          backgroundColor: highlightColor,
          color: 'inherit',
          padding: 0,
          borderRadius: '4px',
          border: `1px solid ${themePalette.white}66`,
          ...(isListMenu && {
            fontWeight: 'bold',
          }),
        }}
      >
        {segment.text}
      </mark>
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>{segment.text}</React.Fragment>
    ),
  );
};
